import type { Filters } from '@ipfabric/utils';
import { isFiltersSimple } from 'components/ApiTable/helpers/isFiltersSimple';
import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { initializeSimpleFilters } from 'components/ApiTable/model/commands/initializeSimpleFilters';
import { openAdvancedFilter } from 'components/ApiTable/model/commands/openAdvancedFilter';
import { setFilters } from 'components/ApiTable/model/commands/setFilters';
import { adjustColumnWidthsForFilter } from 'components/Table/model/commands/adjustColumnWidthsForFilter';
import { selectColumnsByKey } from '../../../Table/model/selectors/selectColumnsByKey';

export type ApplyExternalFiltersCommand = {
  filters: Filters;
};

export const applyExternalFilters: ApiTableCommandFactory<
  ApplyExternalFiltersCommand
> =
  (cmdContext, dispatch) =>
  ({ filters }) => {
    const initialFiltersSimple = isFiltersSimple(
      selectColumnsByKey(cmdContext.getTableModel()),
    )(filters);

    dispatch(initializeSimpleFilters, {
      initialFilters: initialFiltersSimple ? filters : {},
    });
    if (initialFiltersSimple) {
      dispatch(setFilters, { filters, origin: 'simple' });
      cmdContext.getTableModel().dispatch(adjustColumnWidthsForFilter, {
        // need to pass columnKeys due to apiTableModel.simpleFilterFields is not updated yet
        columnKeys: Object.keys(filters),
      });
    } else {
      dispatch(openAdvancedFilter);
      cmdContext.updateState((draft) => {
        draft.advancedFilter.externalFilters = filters;
      });
      dispatch(setFilters, { filters, origin: 'advanced' });
    }
  };
